import { createFileRoute } from "@tanstack/react-router";
import { InitiativePage } from "@/features/initiatives/InitiativePage";

export const Route = createFileRoute("/_app/initiatives/$initiative")({
  component: () => <InitiativePage id={Route.useParams().initiative} />,
});
